/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Frontrow_BookedInputs */

const en_scene_frontrow_booked = /** @type {(inputs: Scene_Frontrow_BookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See you on 10 February at 10:30`)
};

/**
* | output |
* | --- |
* | "See you on 10 February at 10:30" |
*
* @param {Scene_Frontrow_BookedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_frontrow_booked = /** @type {((inputs?: Scene_Frontrow_BookedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Frontrow_BookedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_frontrow_booked(inputs)
});